<template>
    <div class="product-in-cart">
        <div class="row" v-if="!!product">
            
            <div class="col col-image">
                <api-img :comp="product.imagenes_id" />
            </div>

            <div class="col col-info">
                
                <h5 class="txt-name">
                    <router-link target="_blank" :to="'/equipo/'+product.id">{{ product.nombre }}</router-link>
                </h5>

                <div class="row align-items-center">
                    <div class="col-12">
                        <h6 class="txt-sm text-muted">Marca: {{ product.marca }}</h6>
                    </div>
                    <div class="col-12">
                        <h6 class="txt-sm text-muted">Modelo: {{ product.modelo }}</h6>
                    </div>
                    <div class="col col-price">
                        <p>{{ product.precio | currency}} MXN</p>
                    </div>
                </div>

                <template v-if="!viewOnly">
                    <hr class="mt-0 mb-1" />
                    <router-link class="link-sm text-muted" target="_blank" :to="'/equipo/'+product.id">Ver producto</router-link> 
                    <span class="mx-2">|</span> 
                    <a class="link-sm text-danger" @click="cartRemoveProductByIndexInCart(indexInCart)">
                        <i class="far fa-trash-alt"></i> Quitar
                    </a>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import template from '../text-page/template.vue'
export default {
	components: { template },
    name: 'ProductInCart',
    props: {
        productId: {
            type: [Number, String]
        },
        viewOnly: {
            type: [Number, String, Boolean],
            default: false
        },
        indexInCart: {
            type: [Number]
        }
    },
    data: () => {
        return {
            product: null
        }
    },
    methods: {
        ...mapActions(['catalogosGetProductById', 'cartRemoveProductByIndexInCart']),
        async loadProduct() {
            this.product = await this.catalogosGetProductById(this.productId)
        }
    },
    mounted(){
        this.loadProduct()
    },
    watch: {
        'productId'(){
            this.loadProduct()
        }
    }
}
</script>

<style lang="less">
    .product-in-cart {
        
    }
</style>